/**
 * Usage:
 *   <div ec-customers-csv
 *         ec-url='theBlobUrl'
 *         ec-merchant-id='123'
 *         ec-merchant-browser-url='some-url-456'>
 *   </div>
 *
 */
export default function ecCustomersCsv(UtilService) {
  return { restrict: 'A', link: link };

  function link(scope, elem, attr) {
    var anchorAttributes,
      anchor = angular.element('<a/>');

    scope.$watch('vm.url', function() {
      if (!attr.ecUrl) {
        return;
      }

      elem.on('click', function() {
        anchorAttributes = {
          href: attr.ecUrl,
          target: '_blank',
          download: generateFileName(attr.ecMerchantId, attr.ecMerchantBrowserUrl),
        };
        anchor.attr(anchorAttributes)[0].click();
      });
    });

    function generateFileName(id, url) {
      var splitUrl = url.split('-'),
        lastPart = splitUrl[splitUrl.length - 1];

      if (UtilService.isNumeric(lastPart) && lastPart !== id) {
        splitUrl.pop();
        splitUrl.push(id);
      }

      return splitUrl.join('-') + '.csv';
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/merchants/customers-download.directive.js